// extracted by mini-css-extract-plugin
export default {"newsletter":"page8_newsletter__taVRh","mobileAndText":"page8_mobileAndText__7-Vbv"};